import React, { Component } from 'react';


class travelNoteMontreal extends Component {

    render() {


        return ( 

            <section>
        <header>


<nav className="nav-wrapper black">
<div className="container">
    <a href="/" className="brand-logo ">
        <span>Y.X.</span>
    </a>
    
    <a href="" className="sidenav-trigger" data-target="mobile-menu">
    <i className="material-icons">menu</i>
    </a>
    <ul className="right hide-on-med-and-down">
    <li><a href="/travel">Travel</a></li>
    <li><a href="/music">Music</a></li>
    <li><a href="/calligraphy">Calligraphy</a></li>
    
    <li><a href="/cat">🐈</a></li>

    <li><a href="https://www.instagram.com/crys___7" className=" btn-floating btn-small transparent" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-instagram"></i>
    </a></li>
    <li><a href="https://www.youtube.com/channel/UClv5NmxBvWIjid8crocDvZQ" className=" btn-floating btn-small transparent" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-youtube"></i>
    </a></li>
    <li><a href="https://www.facebook.com/profile.php?id=100006981077508" className=" btn-floating btn-small transparent" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-facebook"></i>
    </a></li>
    <li><a href="https://twitter.com/YueqingXie" className=" btn-floating btn-small transparent" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-twitter"></i>
    </a></li>
    <li><a href="/travelNoteMontrealCN" className="btn btn-floating transparent">CN</a></li>
    
    </ul>
    
    <ul className="sidenav grey lighten-2" id="mobile-menu">
        <li><a href="/travel" className="sidenavtext">Travel</a></li>
        <li><a href="/music" className="sidenavtext">Music</a></li>
        <li><a href="/calligraphy" className="sidenavtext">Calligraphy</a></li>
        <li><a href="/cat" className="sidenavtext">My Cat</a></li>
        <li><a href="/#aboutmenav" className="sidenavtext">About Me</a></li>
            <br/>
            <li><a href="/travelNoteMontrealCN" className="sidenavtext">CN</a></li>

    </ul>
</div>
</nav>
</header>

            
            <div className="row hide-on-small-only" id="travelNoteMontreal">
                <div className="col s2 m2 l2">
                    <div>
                        {/* <nav className="nav">
                            <a href="#video4">title 4</a>
                        </nav> */}
                        
                        <ul className="nav">
                        <div className="bigTitle">Montreal</div>
                            {/* <li className="titleDate">
                                <a href="#title0">2018/09/02</a>
                            </li>
                            <li className="smallTitle">
                                <a>0.1/ </a>
                                <a href="#title0">抵达</a>
                            </li> */}
                            <li className="titleDate">
                                <a href="#title1">2015/03/15</a>
                            </li>
                            <li className="smallTitle">
                                <a>1.1/ </a>
                                <a href="#title1">La Banquise</a>
                            </li>

                            <li className="titleDate">
                                <a href="#title2">2015/03/16</a>
                            </li>
                            <li className="smallTitle">
                                <a>2.1/ </a>
                                <a href="#title2">Fairmount Bagel</a>
                            </li>
                            <li className="smallTitle">
                                <a>2.2/ </a>
                                <a href="#title3">Schewartz's Deli</a>
                            </li>
                            <li className="smallTitle">
                                <a>2.3/ </a>
                                <a href="#title4">Jean Talon Market</a>
                            </li>
                            <li className="smallTitle">
                                <a>2.4/ </a>
                                <a href="#title5">Mary, Queen of the World</a>
                            </li>
                            <li className="smallTitle">
                                <a>2.5/ </a>
                                <a href="#title6">McGill University</a>
                            </li>
                            <li className="smallTitle">
                                <a>2.6/ </a>
                                <a href="#title7">Mount Royal</a>
                            </li>
                            <li className="titleDate">
                                <a href="#title8">2015/03/17</a>
                            </li>
                            <li className="smallTitle">
                                <a>3.1/ </a>
                                <a href="#title8">China Town</a>
                            </li>
                            <li className="smallTitle">
                                <a>3.2/ </a>
                                <a href="#title9">Notre-Dame de Québec</a>
                            </li>
                            <li className="smallTitle">
                                <a>3.3/ </a>
                                <a href="#title10">Olympic Stadium</a>
                            </li>
                            <li className="smallTitle">
                                <a>3.4/ </a>
                                <a href="#title11">Biodome</a>
                            </li>
                            <li className="smallTitle">
                                <a>3.5/ </a>
                                <a href="#title12">Rio Tinto Alcan Planetarium</a>
                            </li>
                            <li className="smallTitle">
                                <a>3.6/ </a>
                                <a href="#title13">Insectarium</a>
                            </li>
                            {/* <li className="titleDate">
                                <a href="#title14">2015/03/18</a>
                            </li>
                            <li className="smallTitle">
                                <a>4.1/ </a>
                                <a href="#title14">返程</a>
                            </li> */}


                        </ul>
                    </div>
                </div>

                <div className="col s9 m9 l9 offset-s1 offset-m1 offset-l1 noteMontreal">
                    {/* <div className="video" id="video1">
                        <video controls src="../video/1.mp4" width="560" height="315"></video>
                    </div>
                    <div className="video" id="video2">
                        <video controls src="../video/1.mp4" width="560" height="315"></video>
                    </div>
                    <div className="video" id="video3">
                        <video controls src="../video/1.mp4" width="560" height="315"></video>
                    </div>
                    <div className="video" id="video4">
                        <video controls src="../video/1.mp4" width="560" height="315"></video>
                    </div>
                    <div className="video" id="video5">
                        <video controls src="../video/1.mp4" width="560" height="315"></video>
                    </div>
                    <div className="video" id="video6">
                        <video controls src="../video/1.mp4" width="560" height="315"></video>
                    </div> */}

                        <div className="row">
                            <div className="col s10 m10 l10 offset-s1 offset-m1 offset-l1 ">
                            <div className="row travelDetail">
                                <div className="time col s12 m4 l4">
                                    <i className=" material-icons left">access_time</i>
                                    <span>Departure</span>
                                    <span> / </span>
                                    <span>2015-03-15</span>
                                </div>
                                <div className="day col s12 m4 l4">
                                    <i className=" material-icons left">wb_sunny</i>
                                    <span>Travel Days</span>
                                    <span> / </span>
                                    <span>4 days</span>
                                </div>
                                <div className="people col s12 m4 l4">
                                    <i className=" material-icons left">account_circle</i>
                                    <span>People</span>
                                    <span> / </span>
                                    <span>With Friends</span>
                                </div>
                            </div>
                            <div className="col s1 m1 l1"></div>
                            </div>
                        </div>
{/* 
                    <div className="titles" id="title0">
                        <h4 className="title">Holiday Inn Resort Orlando</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img13/0.jpg" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Holiday+Inn+Resort+Orlando+Lake+Buena+Vista/@28.3722121,-81.504916,17z/data=!3m1!4b1!4m9!3m8!1s0x88e769400504dd55:0x6a7b805e2371072d!5m3!1s2020-11-11!4m1!1i2!8m2!3d28.3722074!4d-81.5027273">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Holiday Inn Resort Orlando</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">
                                <p>酒店是Holiday Inn Resort Orlando - Lake Buena Vista</p>
                                <p>定了五晚，$1600。</p>
                                <p>有游泳池，打印机。晚上可以泡温泉。</p>
                                <p>酒店有通往各个景点的shuttle bus，问前台要时间表。</p>
                                <p>也可以打车前往，离的都没有很远。</p>
                            </div>
                        </div>
                        
                    </div> */}

                    <div className="titles" id="title1">
                        <h4 className="title">La Banquise</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img17/1.jpg" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/La+Banquise/@45.525352,-73.5769467,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc91bcf6fd7097f:0x8fb883c1e73fdf11!8m2!3d45.5253483!4d-73.574758">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">La Banquise</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal1">Introduction</a>
                        <div id="modal1" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">La Banquise - Introduction</h4>
                            <p>All-night diner for Québécois grub & local microbrews, with many poutine options & hefty breakfasts.</p>
                            <p className="grey-text">整晚都可享用Québécois＆和当地微酿啤酒，有许多肉丁选择和丰盛的早餐。</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="http://labanquise.com/">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title2">
                        <h4 className="title" >Fairmount Bagel</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img17/2.jpg" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Fairmount+Bagel/@45.5173305,-73.6036179,14z/data=!4m8!1m2!2m1!1shttps:%2F%2Ffairmountbagel.com%2F!3m4!1s0x4cc9197e3ee6bfe7:0xd247976570d63cad!8m2!3d45.5228777!4d-73.5951705">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Fairmount Bagel</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal2">Introduction</a>
                        <div id="modal2" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Fairmount Bagel - Introduction</h4>
                            <p>Well-known bakery doling out varied flavors of bagels topped with cream cheese, plus other bites.</p>
                            <p className="grey-text">著名的面包店散发出各种口味的百吉饼，上面放着奶油奶酪，还有其他小吃。</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://fairmountbagel.com/">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title3">
                        <h4 className="title">Schewartz's Deli</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img17/3.jpg" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Schwartz's+Deli+-+Sandwiches+-+Steaks/@45.516354,-73.5798288,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc91a3358006b11:0xd961a1e5148bf840!8m2!3d45.5163503!4d-73.5776401">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Schewartz's Deli</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal3">Introduction</a>
                        <div id="modal3" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Schewartz's Deli - Introduction</h4>
                            <p>Renowned deli, one of the oldest in Canada, offering huge sandwiches, smoked meats & more.</p>
                            <p className="grey-text">著名的熟食店，加拿大最古老的熟食店之一，提供巨大的三明治，烟熏肉等。</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://schwartzsdeli.com/index.php?route=common/home">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title4">
                        <h4 className="title">Jean Talon Market</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img17/4.jpg" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Jean+Talon+Market/@45.5361132,-73.6170789,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc919136130849d:0x5c1098d838d87981!8m2!3d45.5361095!4d-73.6148902">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Jean Talon Market</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal4">Introduction</a>
                        <div id="modal4" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Jean Talon Market - Introduction</h4>
                            <p>Jean-Talon Market (French: Marché Jean-Talon) is a farmer's market in Montreal. Located in the Little Italy district, the market is bordered by Jean-Talon Street to the north, Mozart Ave. to the south, Casgrain Ave. to the west and Henri-Julien Ave. to the east. It contains two city-maintained streets both called Place du Marché du Nord. The market is located between the Jean-Talon and De Castelnau metro stations.
                            <br/>
<br/>
It is the largest market in Montreal and the largest open-air market in North America.
                            </p>
                            <p className="grey-text">Jean-Talon市场（法语：MarchéJean-Talon）是蒙特利尔的一个农贸市场。 市场位于小意大利区（Little Italy），北部与让·塔隆街（Jean-Talon Street），南部与莫扎特大道（Mozart Ave.），西部与卡斯格兰大道（Casgrain Ave.）以及东部与亨利·朱利安（Henri-Julien Ave）接壤。 它包含两条由城市维护的街道，均被称为北部广场。 市场位于让·泰隆（Jean-Talon）和De Castelnau地铁站之间。
                            <br/>
<br/>
它是蒙特利尔最大的市场，也是北美最大的露天市场。</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Jean-Talon_Market">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title5">
                        <h4 className="title">Mary, Queen of the World</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img17/5.jpg" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Mary,+Queen+of+the+World+Cathedral/@45.4992137,-73.5704198,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc91a43269acaf9:0xe5211760dfa0dba3!8m2!3d45.49921!4d-73.5682311">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Mary, Queen of the World</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal5">Introduction</a>
                        <div id="modal5" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Mary, Queen of the World - Introduction</h4>
                            <p>Mary, Queen of the World Cathedral or in full Marie, Queen of the World and St. James the Great Cathedral is a minor basilica in Montreal, Quebec, Canada, and the seat of the Roman Catholic archdiocese of Montreal. It is the third largest church in Quebec after Saint Joseph's Oratory (also in Montreal) and the Basilica of Sainte-Anne-de-Beaupré east of Quebec City. The building is 101 m (333 ft) in length, 46 m (150 ft) in width, and a maximum height of 77 m (252 ft) at the cupola, the diameter of which is 23 m (75 ft).
                            <br/>
<br/>
The church is located at 1085 Cathedral Street at the corner of René Lévesque Boulevard and Metcalfe Street, near the Bonaventure metro station and Central Station in downtown Montreal. It and the connected Archdiocese main buildings form the eastern side of Place du Canada, and occupies of dominant presences on Dorchester Square.
<br/>
<br/>
The sacrament of baptism is celebrated in the small chapel. The marble baptismal font is surmounted by a stucco crucifix sculpted by Philippe Hébert.</p>
                            <p className="grey-text">玛丽，世界皇后大教堂或玛丽，世界皇后和圣詹姆斯大教堂，是加拿大蒙特利尔，魁北克省的一座小教堂，是蒙特利尔罗马天主教大主教区的所在地。它是魁北克第三大教堂，仅次于圣约瑟夫大教堂（也在蒙特利尔）和魁北克市以东的圣安妮德比乌佩雷大教堂。该建筑物的长度为101 m（333英尺），宽度为46 m（150 ft），在冲天炉的最大高度为77 m（252 ft），直径为23 m（75 ft）。
                            <br/>
<br/>
教堂位于RenéLévesque大道和Metcalfe街交汇处的1085 Cathedral Street，靠近蒙特利尔市中心的Bonaventure地铁站和中央车站。它和相连的大主教管区主楼形成加拿大广场的东侧，并在多切斯特广场上占主导地位。
<br/>
<br/>
在小教堂里庆祝洗礼的圣礼。大理石洗礼字体由PhilippeHébert雕刻的灰泥耶稣受难像覆盖。 
                            
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Mary,_Queen_of_the_World_Cathedral">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title6">
                        <h4 className="title">McGill University</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img17/6.jpg" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/McGill+University/@45.5047884,-73.5793398,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc91a46510f9635:0xdde4da9200a4ae74!8m2!3d45.5047847!4d-73.5771511">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">McGill University</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal6">Introduction</a>
                        <div id="modal6" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">McGill University - Introduction</h4>
                            <p>McGill University is a public research university in Montreal, Quebec, Canada. Founded in 1821 by royal charter granted by King George IV,  the university bears the name of James McGill, a Scottish merchant whose bequest in 1813 formed the university's precursor, University of McGill College (or simply, McGill College); the name was officially changed to McGill University in 1885.</p>
                            <p className="grey-text">麦吉尔大学是加拿大魁北克省蒙特利尔市的一所公立研究型大学。 该大学由乔治四世国王授予的皇家宪章于1821年创立，以詹姆斯·麦吉尔（James McGill）的名字命名，他是苏格兰商人，他的遗赠于1813年形成该大学的前身，即麦吉尔大学大学（或简称麦吉尔大学）； 该名称于1885年正式更名为麦吉尔大学。</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/McGill_University">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title7">
                        <h4 className="title">Mount Royal</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img17/7.jpg" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Mount+Royal/@45.5071166,-73.5961619,15z/data=!3m1!4b1!4m5!3m4!1s0x4cc91a18b0dacb83:0x9ee51c5e768e560!8m2!3d45.5071024!4d-73.5874071">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Mount Royal</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal7">Introduction</a>
                        <div id="modal7" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Mount Royal - Introduction</h4>
                            <p>Mount Royal is a large intrusive rock hill or small mountain in the city of Montreal, immediately west of Downtown Montreal, Quebec, Canada. The City of Montreal takes its name from Mount Royal.
                            <br/>
<br/>
The hill is part of the Monteregian Hills situated between the Laurentians and the Appalachian Mountains. It gave its Latin name, Mons Regius, to the Monteregian chain. The hill consists of three peaks: Colline de la Croix (or Mont Royal proper) at 233 m (764 ft), Colline d'Outremont (or Mount Murray, in the borough of Outremont) at 211 m (692 ft), and Westmount Summit at 201 m (659 ft) elevation above mean sea level.
                            
                            </p>
                            <p className="grey-text">皇家山（Royal Mount）是位于加拿大魁北克省蒙特利尔市中心以西的蒙特利尔市的一个大型侵入岩山或小山。 蒙特利尔市的名字来自皇家山。
                            <br/>
<br/>
这座山是位于劳伦山脉和阿巴拉契亚山脉之间的蒙特雷根山的一部分。 它把它的拉丁名字Mons Regius赋予了Monteregian连锁店。 这座山峰由三座山峰组成：233 m（764 ft）的Colline de la Croix（或皇家山峰），211 m（692 ft）的Colline d'Outremont（或Outremont镇的Murray峰），以及Westmount 在平均海平面以上201 m（659 ft）处的山顶。</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Mount_Royal">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title8">
                        <h4 className="title" >China Town</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img17/8.jpg" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Chinatown,+Montreal,+QC/@45.5070724,-73.5626212,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc91a51b33d5c8d:0xcea79c01dcba013b!8m2!3d45.5076928!4d-73.5601406">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">China Town</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal8">Introduction</a>
                        <div id="modal8" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">China Town - Introduction</h4>
                            <p>Chinatown in Montreal is located in the area of De la Gauchetière Street in Montreal. The neighbourhood contains many Asian restaurants, food markets, and convenience stores as well being home to many of Montreal's East Asian community centres, such as the Montreal Chinese Hospital and the Montreal Chinese Community and Cultural Center. CHUM Hospital is located in Chinatown.</p>
                            <p className="grey-text">蒙特利尔的唐人街位于蒙特利尔的德拉高史蒂尔街地区。 该社区周围有许多亚洲餐馆，食品市场和便利店，还有蒙特利尔许多东亚社区中心的所在地，例如蒙特利尔中国医院和蒙特利尔中国社区和文化中心。 CHUM医院位于唐人街。</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Chinatown,_Montreal">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title9">
                        <h4 className="title">Notre-Dame de Québec</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img17/9.jpg" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Notre-Dame+de+Qu%C3%A9bec+Basilica-Cathedral/@46.8137809,-71.2082449,17z/data=!3m1!4b1!4m5!3m4!1s0x4cb895ddca0712cb:0x3cd7224ef24279f1!8m2!3d46.8137772!4d-71.2060562">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Notre-Dame de Québec</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal9">Introduction</a>
                        <div id="modal9" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Notre-Dame de Québec - Introduction</h4>
                            <p> The Cathedral-Basilica of Notre-Dame de Québec ("Our Lady of Quebec City"), located at 16, rue de Buade, Quebec City, Quebec, is the primatial church of the Roman Catholic Archdiocese of Quebec.
                            <br/>
<br/>
It is the oldest church in Canada and was the first church in Canada to be elevated to the rank of minor basilica, by Pope Pius IX in 1874. Four governors of New France and the bishops of Quebec are buried in the crypt, including François de Laval, Quebec's first bishop.
<br/>
<br/>
The church is a National Historic Site of Canada, and located within the UNESCO World Heritage Site of Historic District of Old Québec.</p>
                            <p className="grey-text">魁北克圣母大教堂（“圣母魁北克市”）位于魁北克魁北克市布德街rue 16号，是魁北克罗马天主教大主教管区的原始教堂。
                            <br/>
<br/>
它是加拿大最古老的教堂，也是加拿大第一座由小教皇庇护九世于1874年升格为小教堂的教堂。新法兰西的四名州长和魁北克的主教被埋葬在地下室中，包括弗朗索瓦·德 拉瓦尔，魁北克的第一任主教。
<br/>
<br/>
这座教堂是加拿大的国家历史遗址，位于联合国教科文组织魁北克旧城区历史遗址的世界遗产之内。
                           </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Cathedral-Basilica_of_Notre-Dame_de_Qu%C3%A9bec">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title10">
                        <h4 className="title">Olympic Stadium</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img17/10.jpg" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Olympic+Stadium/@45.5568346,-73.5534651,17z/data=!3m1!5s0x4cc91c0c30117aab:0x3333a570583c382e!4m8!1m2!2m1!1sOlympic+Stadium!3m4!1s0x4cc91c0af920b65b:0x2ae457d185b19e69!8m2!3d45.5577438!4d-73.5515478">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Olympic Stadium</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal10">Introduction</a>
                        <div id="modal10" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Olympic Stadium - Introduction</h4>
                            <p>Olympic Stadium is a multi-purpose stadium in Montreal, Canada, located at Olympic Park in the Hochelaga-Maisonneuve district of the city. Built in the mid-1970s as the main venue for the 1976 Summer Olympics, it is nicknamed "The Big O", a reference to both its name and to the doughnut-shape of the permanent component of the stadium's roof. The tower standing next to the stadium, The Montreal Tower, is the tallest inclined tower in the world with an angle elevation of 45 degrees. It is also called "The Big Owe" to reference the astronomical cost of the stadium and the 1976 Olympics as a whole.
                            <br/>
<br/>
The stadium is the largest by seating capacity in Canada. After the Olympics, artificial turf was installed and it became the home of Montreal's professional baseball and football teams. The Montreal Alouettes of the CFL returned to their previous home of Molson Stadium in 1998 for regular season games, but continued to use Olympic Stadium for playoff and Grey Cup games until 2014 when they returned to Molson Stadium for all of their games. </p>
                            <p className="grey-text">奥林匹克体育场是位于加拿大蒙特利尔的多功能体育场，位于城市Hochelaga-Maisonneuve区的奥林匹克公园。它建于1970年代中期，是1976年夏季奥林匹克运动会的主要场馆，因此被昵称为“大O”，既指其名称，又指体育场屋顶永久部件的甜甜圈形状。紧邻体育场的塔楼，蒙特利尔塔，是世界上最高的倾斜塔，仰角为45度。它也被称为“ Big Owe”，是指体育场和整个1976年奥运会的天文成本。
<br/>
<br/>
该体育场是加拿大座位最多的体育场。奥运会之后，安装了人造草皮，它成为蒙特利尔专业棒球队和橄榄球队的所在地。 1998年，CFL的蒙特利尔长者队回到了他们以前的莫尔森体育馆进行常规赛，但是直到2014年他们回到莫尔森体育馆进行所有比赛后，他们都继续使用奥林匹克体育场进行季后赛和灰色杯比赛。
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Olympic_Stadium_(Montreal)">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        <div className="titleContent">
                            <h5>2015/03/17</h5>
                            <div className="row">
                                <div className="col s12 m12 l5">
                                    <img src="../img18/1.jpg" alt="" className="responsive-img"></img>
                                </div>
                                <div className="col s12 m12 l6 offset-l1">
                                    <p>Tickets for three venues

</p>
                                    <p>The student fare for the three venues is $35.75 in total</p>
                                    <p>If you are a Quebec resident, it will be 6 dollars cheaper.</p>
                                    <p>You can also add $15 to Montreal Tower.</p>
                                    <p>It was winter when I visited, so the botanical garden was closed.</p>
                                </div>
                            </div>

                        </div>
                        
                    </div>

                    <div className="titles" id="title11">
                        <h4 className="title">Biodome</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img17/11.jpg" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Biodome/@45.5596582,-73.5519076,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc91c0d04c267b1:0x1cc677ac9fbe265b!8m2!3d45.5596545!4d-73.5497189">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Biodome</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal11">Introduction</a>
                        <div id="modal11" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Biodome - Introduction</h4>
                            <p>The Montreal Biodome (French: Biodôme de Montréal) is a facility located at Olympic Park in the Mercier–Hochelaga-Maisonneuve neighbourhood of Montreal, Quebec, Canada, that allows visitors to walk through replicas of four ecosystems found in the Americas. The building was originally constructed for the 1976 Olympic Games as a velodrome. It hosted both track cycling and judo events. Renovations on the building began in 1989 and in 1992 the indoor nature exhibit was opened.
                            <br/>
<br/>
The Montreal Biodome is one of four facilities that make part of the largest natural science museum complex in Canada, Space for Life, which also includes the Montreal Insectarium, Montreal Botanical Garden, and Rio Tinto Alcan Planetarium. It is an accredited member of both the Association of Zoos and Aquariums (AZA) and the Canada's Accredited Zoos and Aquariums association (CAZA).
                            </p>
                            <p className="grey-text">蒙特利尔生物馆（法语：蒙特利尔生物馆）是位于加拿大魁北克省蒙特利尔市Mercier-Hochelaga-Maisonneuve社区奥林匹克公园的设施，游客可以浏览美洲发现的四个生态系统的副本。 该建筑最初是为1976年奥运会建造的赛车场。 它举办了田径自行车和柔道比赛。 建筑物的翻新工程于1989年开始，1992年室内自然展览开始了。
                            <br/>
<br/>
蒙特利尔生物穹顶是构成加拿大最大自然科学博物馆综合体“生命的空间”的四个设施之一，其中还包括蒙特利尔昆虫馆，蒙特利尔植物园和力拓阿尔坎天文馆。 它是动物园和水族馆协会（AZA）和加拿大认可的动物园和水族馆协会（CAZA）的认可成员。</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Montreal_Biodome">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title12">
                        <h4 className="title">Rio Tinto Alcan Planetarium</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img17/12.jpg" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Rio+Tinto+Alcan+Planetarium/@45.5606705,-73.5527587,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc91a5df032ba8f:0xa9de0973a97901f2!8m2!3d45.5606668!4d-73.55057">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Rio Tinto Alcan Planetarium</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal12">Introduction</a>
                        <div id="modal12" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Rio Tinto Alcan Planetarium - Introduction</h4>
                            <p>The Rio Tinto Alcan Planetarium (French: Planétarium Rio Tinto Alcan) is the successor to the Montreal Planetarium, and is located in the Espace pour la Vie, near the Olympic Stadium and the Biodome in Montreal, Quebec, Canada. The new installation has two separate theatres as well as exhibits on space and astronomy. It was officially opened in April 2013.
                            <br/>
<br/>
The building, designed by Cardin + Ramirez et Associés, Architectes, is certified as LEED Platinum.
                            </p>
                            <p className="grey-text">Rio Tinto Alcan天文馆（法语：PlanétariumRio Tinto Alcan）是蒙特利尔天文馆的后继者，位于Espace pour la Vie，靠近奥林匹克体育场和加拿大魁北克蒙特利尔的Biodome。 新装置有两个独立的剧院以及关于空间和天文学的展览。 它于2013年4月正式开放。
                            <br/>
<br/>
该建筑由Cardin + Ramirez etAssociés，Architectes设计，已获LEED白金认证。</p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Rio_Tinto_Alcan_Planetarium">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>

                    <div className="titles" id="title13">
                        <h4 className="title">Insectarium</h4>
                        
                        <div className="row">
                            <div className="col s12 m12 l5">
                                <img src="../img17/13.jpg" alt="" className="responsive-img"></img>
                                <br></br>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Montreal+Insectarium/@45.5610321,-73.5600353,17z/data=!4m8!1m2!2m1!1sInsectarium!3m4!1s0x4cc91c095abe83c7:0x8c6584b75a2ea66f!8m2!3d45.5610184!4d-73.5578418">
                                    <i className="tiny material-icons">location_on</i>
                                    <span className="titleMap">Montreal Insectarium</span>
                                </a>
                            </div>
                            <div className="col s12 m12 l6 offset-l1">

                            <div className="details">


                        <a className="btn-flat modal-trigger right info " href="#modal13">Introduction</a>
                        <div id="modal13" className="modal modal-fixed-footer">
                            <div className="modal-content">
                            <h4 className="title">Montreal Insectarium - Introduction</h4>
                            <p>The Montreal Insectarium (French: Insectarium de Montréal) is a natural history museum located in Montreal, Quebec, Canada, featuring a large quantity of insects from all around the world. It is the largest insect museum in North America and among the largest insectariums worldwide. It was founded by Georges Brossard and opened on February 7, 1990. Its average attendance is 400,000 visitors per year. It displays both live and dead insect collections, from butterflies to bees and ants.
                            <br/>
<br/>
It is one of the city's most popular tourist attractions, along with the Montreal Botanical Garden, Montreal Planetarium and the Montreal Biodome.
<br/>
<br/>
Seen from the sky, the Montréal Insectarium resembles a stylized insect. This can also be seen from the observatory of Montréal's Olympic Stadium.</p>
                            <p className="grey-text">蒙特利尔昆虫馆（法语：蒙特利尔昆虫馆）是位于加拿大魁北克蒙特利尔的自然历史博物馆，汇集了来自世界各地的大量昆虫。 它是北美最大的昆虫博物馆，也是全球最大的昆虫馆之一。 它由乔治·布罗萨德（Georges Brossard）创立，于1990年2月7日开业。每年的平均访客量为40万。 它展示了从昆虫到蝴蝶，蜜蜂和蚂蚁的活昆虫和死昆虫。
                            <br/>
<br/>
它是蒙特利尔最受欢迎的旅游景点之一，还有蒙特利尔植物园，蒙特利尔天文馆和蒙特利尔生物博物馆。
<br/>
<br/>
从空中看，蒙特利尔昆虫保育场像一只程式化的昆虫。 这也可以从蒙特利尔奥林匹克体育场的天文台看到。
                            </p>
                            <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Montreal_Insectarium">
                                {/* <i className="material-icons left">details</i>   */}
                                <span className="blue-text">[Source From...]</span>
                            </a>    
                            </div>
                            <div className="modal-footer">
                            <a href="#!" className="modal-close btn-flat">Close</a>
                            </div>
                        </div>

                        </div>
                            </div>
                        </div>

                  
                        {/* <div className="titleContent">
                        </div> */}
                        
                    </div>



                    <h4 className="title"> </h4>

                    {/* <div className="Comment">
                    
                        <div className="row">   
                        <div className="col s1 m1 l1">
                            <a className="btn btn-floating black lighten-1 ">YX</a>
                        </div>
                        <div className="col s11 m11 l11 commentContent">
                            <form action="">
                                <div className="input-field">
                                    <textarea id="message" className="materialize-textarea"></textarea>
                                    <label htmlFor="message">发表评论</label>
                                </div>
                            </form>
                        </div>
                        </div>

                      

                    </div> */}

   



                </div>
            </div>

            <div className="row hide-on-med-and-up" id="travelNoteMontreal">

<div className="col s12 m12 l12 noteMontreal">
    {/* <div className="video" id="video1">
        <video controls src="../video/1.mp4" width="560" height="315"></video>
    </div>
    <div className="video" id="video2">
        <video controls src="../video/1.mp4" width="560" height="315"></video>
    </div>
    <div className="video" id="video3">
        <video controls src="../video/1.mp4" width="560" height="315"></video>
    </div>
    <div className="video" id="video4">
        <video controls src="../video/1.mp4" width="560" height="315"></video>
    </div>
    <div className="video" id="video5">
        <video controls src="../video/1.mp4" width="560" height="315"></video>
    </div>
    <div className="video" id="video6">
        <video controls src="../video/1.mp4" width="560" height="315"></video>
    </div> */}

    <a href="" className="sidenav-trigger" data-target="mobile-menu999">
        <i className="material-icons smallnotenav" >menu</i>
    </a>
    <ul className="sidenav grey lighten-2 sidenav999" id="mobile-menu999">
    <div className="bigTitle">Montreal</div>
            {/* <li className="titleDate">
                <a href="#title0">2018/09/02</a>
            </li>
            <li className="smallTitle">
                <a>0.1/ </a>
                <a href="#title0">抵达</a>
            </li> */}
            <li className="titleDate">
                <a href="#title14">2015/03/15</a>
            </li>
            <li className="smallTitle">
             
                <a href="#title14">La Banquise</a>
            </li>

            <li className="titleDate">
                <a href="#title15">2015/03/16</a>
            </li>
            <li className="smallTitle">
               
                <a href="#title15">Fairmount Bagel</a>
            </li>
            <li className="smallTitle">
              
                <a href="#title16">Schewartz's Deli</a>
            </li>
            <li className="smallTitle">
               
                <a href="#title17">Jean Talon Market</a>
            </li>
            <li className="smallTitle">
              
                <a href="#title18">Mary, Queen of the World</a>
            </li>
            <li className="smallTitle">
             
                <a href="#title19">McGill University</a>
            </li>
            <li className="smallTitle">
               
                <a href="#title20">Mount Royal</a>
            </li>
            <li className="titleDate">
                <a href="#title21">2015/03/17</a>
            </li>
            <li className="smallTitle">
               
                <a href="#title21">China Town</a>
            </li>
            <li className="smallTitle">
              
                <a href="#title22">Notre-Dame de Québec</a>
            </li>
            <li className="smallTitle">
              
                <a href="#title23">Olympic Stadium</a>
            </li>
            <li className="smallTitle">
             
                <a href="#title24">Biodome</a>
            </li>
            <li className="smallTitle">
               
                <a href="#title25">Rio Tinto Alcan Planetarium</a>
            </li>
            <li className="smallTitle">
              
                <a href="#title26">Insectarium</a>
            </li>
        
    </ul>


        <div className="row">
            <div className="col s10 m10 l10 offset-s1 offset-m1 offset-l1 ">
            <div className="row travelDetail">
                <div className="time col s12 m4 l4">
                    <i className=" material-icons left">access_time</i>
                    <span>Departure</span>
                    <span> / </span>
                    <span>2015-03-15</span>
                </div>
                <div className="day col s12 m4 l4">
                    <i className=" material-icons left">wb_sunny</i>
                    <span>Travel Days</span>
                    <span> / </span>
                    <span>4 days</span>
                </div>
                <div className="people col s12 m4 l4">
                    <i className=" material-icons left">account_circle</i>
                    <span>People</span>
                    <span> / </span>
                    <span>With Friends</span>
                </div>
            </div>
            <div className="col s1 m1 l1"></div>
            </div>
        </div>

        <div className="titles" id="title14">
<h4 className="title">La Banquise</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img17/1.jpg" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/La+Banquise/@45.525352,-73.5769467,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc91bcf6fd7097f:0x8fb883c1e73fdf11!8m2!3d45.5253483!4d-73.574758">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">La Banquise</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9991">Introduction</a>
<div id="modal9991" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">La Banquise - Introduction</h4>
    <p>All-night diner for Québécois grub & local microbrews, with many poutine options & hefty breakfasts.</p>
    <p className="grey-text">整晚都可享用Québécois＆和当地微酿啤酒，有许多肉丁选择和丰盛的早餐。</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="http://labanquise.com/">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title15">
<h4 className="title" >Fairmount Bagel</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img17/2.jpg" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Fairmount+Bagel/@45.5173305,-73.6036179,14z/data=!4m8!1m2!2m1!1shttps:%2F%2Ffairmountbagel.com%2F!3m4!1s0x4cc9197e3ee6bfe7:0xd247976570d63cad!8m2!3d45.5228777!4d-73.5951705">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Fairmount Bagel</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9992">Introduction</a>
<div id="modal9992" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Fairmount Bagel - Introduction</h4>
    <p>Well-known bakery doling out varied flavors of bagels topped with cream cheese, plus other bites.</p>
    <p className="grey-text">著名的面包店散发出各种口味的百吉饼，上面放着奶油奶酪，还有其他小吃。</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://fairmountbagel.com/">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title16">
<h4 className="title">Schewartz's Deli</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img17/3.jpg" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Schwartz's+Deli+-+Sandwiches+-+Steaks/@45.516354,-73.5798288,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc91a3358006b11:0xd961a1e5148bf840!8m2!3d45.5163503!4d-73.5776401">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Schewartz's Deli</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9993">Introduction</a>
<div id="modal9993" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Schewartz's Deli - Introduction</h4>
    <p>Renowned deli, one of the oldest in Canada, offering huge sandwiches, smoked meats & more.</p>
    <p className="grey-text">著名的熟食店，加拿大最古老的熟食店之一，提供巨大的三明治，烟熏肉等。</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://schwartzsdeli.com/index.php?route=common/home">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title17">
<h4 className="title">Jean Talon Market</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img17/4.jpg" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Jean+Talon+Market/@45.5361132,-73.6170789,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc919136130849d:0x5c1098d838d87981!8m2!3d45.5361095!4d-73.6148902">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Jean Talon Market</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9994">Introduction</a>
<div id="modal9994" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Jean Talon Market - Introduction</h4>
    <p>Jean-Talon Market (French: Marché Jean-Talon) is a farmer's market in Montreal. Located in the Little Italy district, the market is bordered by Jean-Talon Street to the north, Mozart Ave. to the south, Casgrain Ave. to the west and Henri-Julien Ave. to the east. It contains two city-maintained streets both called Place du Marché du Nord. The market is located between the Jean-Talon and De Castelnau metro stations.
    <br/>
<br/>
It is the largest market in Montreal and the largest open-air market in North America.
    </p>
    <p className="grey-text">Jean-Talon市场（法语：MarchéJean-Talon）是蒙特利尔的一个农贸市场。 市场位于小意大利区（Little Italy），北部与让·塔隆街（Jean-Talon Street），南部与莫扎特大道（Mozart Ave.），西部与卡斯格兰大道（Casgrain Ave.）以及东部与亨利·朱利安（Henri-Julien Ave）接壤。 它包含两条由城市维护的街道，均被称为北部广场。 市场位于让·泰隆（Jean-Talon）和De Castelnau地铁站之间。
    <br/>
<br/>
它是蒙特利尔最大的市场，也是北美最大的露天市场。</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Jean-Talon_Market">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title18">
<h4 className="title">Mary, Queen of the World</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img17/5.jpg" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Mary,+Queen+of+the+World+Cathedral/@45.4992137,-73.5704198,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc91a43269acaf9:0xe5211760dfa0dba3!8m2!3d45.49921!4d-73.5682311">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Mary, Queen of the World</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9995">Introduction</a>
<div id="modal9995" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Mary, Queen of the World - Introduction</h4>
    <p>Mary, Queen of the World Cathedral or in full Marie, Queen of the World and St. James the Great Cathedral is a minor basilica in Montreal, Quebec, Canada, and the seat of the Roman Catholic archdiocese of Montreal. It is the third largest church in Quebec after Saint Joseph's Oratory (also in Montreal) and the Basilica of Sainte-Anne-de-Beaupré east of Quebec City. The building is 101 m (333 ft) in length, 46 m (150 ft) in width, and a maximum height of 77 m (252 ft) at the cupola, the diameter of which is 23 m (75 ft).
    <br/>
<br/>
The church is located at 1085 Cathedral Street at the corner of René Lévesque Boulevard and Metcalfe Street, near the Bonaventure metro station and Central Station in downtown Montreal. It and the connected Archdiocese main buildings form the eastern side of Place du Canada, and occupies of dominant presences on Dorchester Square.
<br/>
<br/>
The sacrament of baptism is celebrated in the small chapel. The marble baptismal font is surmounted by a stucco crucifix sculpted by Philippe Hébert.</p>
    <p className="grey-text">玛丽，世界皇后大教堂或玛丽，世界皇后和圣詹姆斯大教堂，是加拿大蒙特利尔，魁北克省的一座小教堂，是蒙特利尔罗马天主教大主教区的所在地。它是魁北克第三大教堂，仅次于圣约瑟夫大教堂（也在蒙特利尔）和魁北克市以东的圣安妮德比乌佩雷大教堂。该建筑物的长度为101 m（333英尺），宽度为46 m（150 ft），在冲天炉的最大高度为77 m（252 ft），直径为23 m（75 ft）。
    <br/>
<br/>
教堂位于RenéLévesque大道和Metcalfe街交汇处的1085 Cathedral Street，靠近蒙特利尔市中心的Bonaventure地铁站和中央车站。它和相连的大主教管区主楼形成加拿大广场的东侧，并在多切斯特广场上占主导地位。
<br/>
<br/>
在小教堂里庆祝洗礼的圣礼。大理石洗礼字体由PhilippeHébert雕刻的灰泥耶稣受难像覆盖。 
    
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Mary,_Queen_of_the_World_Cathedral">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title19">
<h4 className="title">McGill University</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img17/6.jpg" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/McGill+University/@45.5047884,-73.5793398,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc91a46510f9635:0xdde4da9200a4ae74!8m2!3d45.5047847!4d-73.5771511">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">McGill University</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9996">Introduction</a>
<div id="modal9996" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">McGill University - Introduction</h4>
    <p>McGill University is a public research university in Montreal, Quebec, Canada. Founded in 1821 by royal charter granted by King George IV,  the university bears the name of James McGill, a Scottish merchant whose bequest in 1813 formed the university's precursor, University of McGill College (or simply, McGill College); the name was officially changed to McGill University in 1885.</p>
    <p className="grey-text">麦吉尔大学是加拿大魁北克省蒙特利尔市的一所公立研究型大学。 该大学由乔治四世国王授予的皇家宪章于1821年创立，以詹姆斯·麦吉尔（James McGill）的名字命名，他是苏格兰商人，他的遗赠于1813年形成该大学的前身，即麦吉尔大学大学（或简称麦吉尔大学）； 该名称于1885年正式更名为麦吉尔大学。</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/McGill_University">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title20">
<h4 className="title">Mount Royal</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img17/7.jpg" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Mount+Royal/@45.5071166,-73.5961619,15z/data=!3m1!4b1!4m5!3m4!1s0x4cc91a18b0dacb83:0x9ee51c5e768e560!8m2!3d45.5071024!4d-73.5874071">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Mount Royal</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9997">Introduction</a>
<div id="modal9997" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Mount Royal - Introduction</h4>
    <p>Mount Royal is a large intrusive rock hill or small mountain in the city of Montreal, immediately west of Downtown Montreal, Quebec, Canada. The City of Montreal takes its name from Mount Royal.
    <br/>
<br/>
The hill is part of the Monteregian Hills situated between the Laurentians and the Appalachian Mountains. It gave its Latin name, Mons Regius, to the Monteregian chain. The hill consists of three peaks: Colline de la Croix (or Mont Royal proper) at 233 m (764 ft), Colline d'Outremont (or Mount Murray, in the borough of Outremont) at 211 m (692 ft), and Westmount Summit at 201 m (659 ft) elevation above mean sea level.
    
    </p>
    <p className="grey-text">皇家山（Royal Mount）是位于加拿大魁北克省蒙特利尔市中心以西的蒙特利尔市的一个大型侵入岩山或小山。 蒙特利尔市的名字来自皇家山。
    <br/>
<br/>
这座山是位于劳伦山脉和阿巴拉契亚山脉之间的蒙特雷根山的一部分。 它把它的拉丁名字Mons Regius赋予了Monteregian连锁店。 这座山峰由三座山峰组成：233 m（764 ft）的Colline de la Croix（或皇家山峰），211 m（692 ft）的Colline d'Outremont（或Outremont镇的Murray峰），以及Westmount 在平均海平面以上201 m（659 ft）处的山顶。</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Mount_Royal">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title21">
<h4 className="title" >China Town</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img17/8.jpg" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Chinatown,+Montreal,+QC/@45.5070724,-73.5626212,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc91a51b33d5c8d:0xcea79c01dcba013b!8m2!3d45.5076928!4d-73.5601406">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">China Town</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9998">Introduction</a>
<div id="modal9998" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">China Town - Introduction</h4>
    <p>Chinatown in Montreal is located in the area of De la Gauchetière Street in Montreal. The neighbourhood contains many Asian restaurants, food markets, and convenience stores as well being home to many of Montreal's East Asian community centres, such as the Montreal Chinese Hospital and the Montreal Chinese Community and Cultural Center. CHUM Hospital is located in Chinatown.</p>
    <p className="grey-text">蒙特利尔的唐人街位于蒙特利尔的德拉高史蒂尔街地区。 该社区周围有许多亚洲餐馆，食品市场和便利店，还有蒙特利尔许多东亚社区中心的所在地，例如蒙特利尔中国医院和蒙特利尔中国社区和文化中心。 CHUM医院位于唐人街。</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Chinatown,_Montreal">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title22">
<h4 className="title">Notre-Dame de Québec</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img17/9.jpg" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Notre-Dame+de+Qu%C3%A9bec+Basilica-Cathedral/@46.8137809,-71.2082449,17z/data=!3m1!4b1!4m5!3m4!1s0x4cb895ddca0712cb:0x3cd7224ef24279f1!8m2!3d46.8137772!4d-71.2060562">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Notre-Dame de Québec</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal9999">Introduction</a>
<div id="modal9999" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Notre-Dame de Québec - Introduction</h4>
    <p> The Cathedral-Basilica of Notre-Dame de Québec ("Our Lady of Quebec City"), located at 16, rue de Buade, Quebec City, Quebec, is the primatial church of the Roman Catholic Archdiocese of Quebec.
    <br/>
<br/>
It is the oldest church in Canada and was the first church in Canada to be elevated to the rank of minor basilica, by Pope Pius IX in 1874. Four governors of New France and the bishops of Quebec are buried in the crypt, including François de Laval, Quebec's first bishop.
<br/>
<br/>
The church is a National Historic Site of Canada, and located within the UNESCO World Heritage Site of Historic District of Old Québec.</p>
    <p className="grey-text">魁北克圣母大教堂（“圣母魁北克市”）位于魁北克魁北克市布德街rue 16号，是魁北克罗马天主教大主教管区的原始教堂。
    <br/>
<br/>
它是加拿大最古老的教堂，也是加拿大第一座由小教皇庇护九世于1874年升格为小教堂的教堂。新法兰西的四名州长和魁北克的主教被埋葬在地下室中，包括弗朗索瓦·德 拉瓦尔，魁北克的第一任主教。
<br/>
<br/>
这座教堂是加拿大的国家历史遗址，位于联合国教科文组织魁北克旧城区历史遗址的世界遗产之内。
   </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Cathedral-Basilica_of_Notre-Dame_de_Qu%C3%A9bec">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title23">
<h4 className="title">Olympic Stadium</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img17/10.jpg" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Olympic+Stadium/@45.5568346,-73.5534651,17z/data=!3m1!5s0x4cc91c0c30117aab:0x3333a570583c382e!4m8!1m2!2m1!1sOlympic+Stadium!3m4!1s0x4cc91c0af920b65b:0x2ae457d185b19e69!8m2!3d45.5577438!4d-73.5515478">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Olympic Stadium</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99910">Introduction</a>
<div id="modal99910" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Olympic Stadium - Introduction</h4>
    <p>Olympic Stadium is a multi-purpose stadium in Montreal, Canada, located at Olympic Park in the Hochelaga-Maisonneuve district of the city. Built in the mid-1970s as the main venue for the 1976 Summer Olympics, it is nicknamed "The Big O", a reference to both its name and to the doughnut-shape of the permanent component of the stadium's roof. The tower standing next to the stadium, The Montreal Tower, is the tallest inclined tower in the world with an angle elevation of 45 degrees. It is also called "The Big Owe" to reference the astronomical cost of the stadium and the 1976 Olympics as a whole.
    <br/>
<br/>
The stadium is the largest by seating capacity in Canada. After the Olympics, artificial turf was installed and it became the home of Montreal's professional baseball and football teams. The Montreal Alouettes of the CFL returned to their previous home of Molson Stadium in 1998 for regular season games, but continued to use Olympic Stadium for playoff and Grey Cup games until 2014 when they returned to Molson Stadium for all of their games. </p>
    <p className="grey-text">奥林匹克体育场是位于加拿大蒙特利尔的多功能体育场，位于城市Hochelaga-Maisonneuve区的奥林匹克公园。它建于1970年代中期，是1976年夏季奥林匹克运动会的主要场馆，因此被昵称为“大O”，既指其名称，又指体育场屋顶永久部件的甜甜圈形状。紧邻体育场的塔楼，蒙特利尔塔，是世界上最高的倾斜塔，仰角为45度。它也被称为“ Big Owe”，是指体育场和整个1976年奥运会的天文成本。
<br/>
<br/>
该体育场是加拿大座位最多的体育场。奥运会之后，安装了人造草皮，它成为蒙特利尔专业棒球队和橄榄球队的所在地。 1998年，CFL的蒙特利尔长者队回到了他们以前的莫尔森体育馆进行常规赛，但是直到2014年他们回到莫尔森体育馆进行所有比赛后，他们都继续使用奥林匹克体育场进行季后赛和灰色杯比赛。
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Olympic_Stadium_(Montreal)">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


<div className="titleContent">
    <h5>2015/03/17</h5>
    <div className="row">
        <div className="col s12 m12 l5">
            <img src="../img18/1.jpg" alt="" className="responsive-img"></img>
        </div>
        <div className="col s12 m12 l6 offset-l1">
            <p>Tickets for three venues

</p>
            <p>The student fare for the three venues is $35.75 in total</p>
            <p>If you are a Quebec resident, it will be 6 dollars cheaper.</p>
            <p>You can also add $15 to Montreal Tower.</p>
            <p>It was winter when I visited, so the botanical garden was closed.</p>
        </div>
    </div>

</div>

</div>

<div className="titles" id="title24">
<h4 className="title">Biodome</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img17/11.jpg" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Biodome/@45.5596582,-73.5519076,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc91c0d04c267b1:0x1cc677ac9fbe265b!8m2!3d45.5596545!4d-73.5497189">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Biodome</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99911">Introduction</a>
<div id="modal99911" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Biodome - Introduction</h4>
    <p>The Montreal Biodome (French: Biodôme de Montréal) is a facility located at Olympic Park in the Mercier–Hochelaga-Maisonneuve neighbourhood of Montreal, Quebec, Canada, that allows visitors to walk through replicas of four ecosystems found in the Americas. The building was originally constructed for the 1976 Olympic Games as a velodrome. It hosted both track cycling and judo events. Renovations on the building began in 1989 and in 1992 the indoor nature exhibit was opened.
    <br/>
<br/>
The Montreal Biodome is one of four facilities that make part of the largest natural science museum complex in Canada, Space for Life, which also includes the Montreal Insectarium, Montreal Botanical Garden, and Rio Tinto Alcan Planetarium. It is an accredited member of both the Association of Zoos and Aquariums (AZA) and the Canada's Accredited Zoos and Aquariums association (CAZA).
    </p>
    <p className="grey-text">蒙特利尔生物馆（法语：蒙特利尔生物馆）是位于加拿大魁北克省蒙特利尔市Mercier-Hochelaga-Maisonneuve社区奥林匹克公园的设施，游客可以浏览美洲发现的四个生态系统的副本。 该建筑最初是为1976年奥运会建造的赛车场。 它举办了田径自行车和柔道比赛。 建筑物的翻新工程于1989年开始，1992年室内自然展览开始了。
    <br/>
<br/>
蒙特利尔生物穹顶是构成加拿大最大自然科学博物馆综合体“生命的空间”的四个设施之一，其中还包括蒙特利尔昆虫馆，蒙特利尔植物园和力拓阿尔坎天文馆。 它是动物园和水族馆协会（AZA）和加拿大认可的动物园和水族馆协会（CAZA）的认可成员。</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Montreal_Biodome">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title25">
<h4 className="title">Rio Tinto Alcan Planetarium</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img17/12.jpg" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Rio+Tinto+Alcan+Planetarium/@45.5606705,-73.5527587,17z/data=!3m1!4b1!4m5!3m4!1s0x4cc91a5df032ba8f:0xa9de0973a97901f2!8m2!3d45.5606668!4d-73.55057">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Rio Tinto Alcan Planetarium</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99912">Introduction</a>
<div id="modal99912" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Rio Tinto Alcan Planetarium - Introduction</h4>
    <p>The Rio Tinto Alcan Planetarium (French: Planétarium Rio Tinto Alcan) is the successor to the Montreal Planetarium, and is located in the Espace pour la Vie, near the Olympic Stadium and the Biodome in Montreal, Quebec, Canada. The new installation has two separate theatres as well as exhibits on space and astronomy. It was officially opened in April 2013.
    <br/>
<br/>
The building, designed by Cardin + Ramirez et Associés, Architectes, is certified as LEED Platinum.
    </p>
    <p className="grey-text">Rio Tinto Alcan天文馆（法语：PlanétariumRio Tinto Alcan）是蒙特利尔天文馆的后继者，位于Espace pour la Vie，靠近奥林匹克体育场和加拿大魁北克蒙特利尔的Biodome。 新装置有两个独立的剧院以及关于空间和天文学的展览。 它于2013年4月正式开放。
    <br/>
<br/>
该建筑由Cardin + Ramirez etAssociés，Architectes设计，已获LEED白金认证。</p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Rio_Tinto_Alcan_Planetarium">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>

<div className="titles" id="title26">
<h4 className="title">Insectarium</h4>

<div className="row">
    <div className="col s12 m12 l5">
        <img src="../img17/13.jpg" alt="" className="responsive-img"></img>
        <br></br>
        <a target="_blank" rel="noopener noreferrer" href="https://www.google.ca/maps/place/Montreal+Insectarium/@45.5610321,-73.5600353,17z/data=!4m8!1m2!2m1!1sInsectarium!3m4!1s0x4cc91c095abe83c7:0x8c6584b75a2ea66f!8m2!3d45.5610184!4d-73.5578418">
            <i className="tiny material-icons">location_on</i>
            <span className="titleMap">Montreal Insectarium</span>
        </a>
    </div>
    <div className="col s12 m12 l6 offset-l1">

    <div className="details">


<a className="btn-flat modal-trigger right info " href="#modal99913">Introduction</a>
<div id="modal99913" className="modal modal-fixed-footer">
    <div className="modal-content">
    <h4 className="title">Montreal Insectarium - Introduction</h4>
    <p>The Montreal Insectarium (French: Insectarium de Montréal) is a natural history museum located in Montreal, Quebec, Canada, featuring a large quantity of insects from all around the world. It is the largest insect museum in North America and among the largest insectariums worldwide. It was founded by Georges Brossard and opened on February 7, 1990. Its average attendance is 400,000 visitors per year. It displays both live and dead insect collections, from butterflies to bees and ants.
    <br/>
<br/>
It is one of the city's most popular tourist attractions, along with the Montreal Botanical Garden, Montreal Planetarium and the Montreal Biodome.
<br/>
<br/>
Seen from the sky, the Montréal Insectarium resembles a stylized insect. This can also be seen from the observatory of Montréal's Olympic Stadium.</p>
    <p className="grey-text">蒙特利尔昆虫馆（法语：蒙特利尔昆虫馆）是位于加拿大魁北克蒙特利尔的自然历史博物馆，汇集了来自世界各地的大量昆虫。 它是北美最大的昆虫博物馆，也是全球最大的昆虫馆之一。 它由乔治·布罗萨德（Georges Brossard）创立，于1990年2月7日开业。每年的平均访客量为40万。 它展示了从昆虫到蝴蝶，蜜蜂和蚂蚁的活昆虫和死昆虫。
    <br/>
<br/>
它是蒙特利尔最受欢迎的旅游景点之一，还有蒙特利尔植物园，蒙特利尔天文馆和蒙特利尔生物博物馆。
<br/>
<br/>
从空中看，蒙特利尔昆虫保育场像一只程式化的昆虫。 这也可以从蒙特利尔奥林匹克体育场的天文台看到。
    </p>
    <a className="right" target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Montreal_Insectarium">
        {/* <i className="material-icons left">details</i>   */}
        <span className="blue-text">[Source From...]</span>
    </a>    
    </div>
    <div className="modal-footer">
    <a href="#!" className="modal-close btn-flat">Close</a>
    </div>
</div>

</div>
    </div>
</div>


{/* <div className="titleContent">
</div> */}

</div>


    <h4 className="title"> </h4>

    {/* <div className="Comment">
    
        <div className="row">   
        <div className="col s1 m1 l1">
            <a className="btn btn-floating black lighten-1 ">YX</a>
        </div>
        <div className="col s11 m11 l11 commentContent">
            <form action="">
                <div className="input-field">
                    <textarea id="message" className="materialize-textarea"></textarea>
                    <label htmlFor="message">发表评论</label>
                </div>
            </form>
        </div>
        </div>

      

    </div> */}




</div>
</div>
            
            
            <footer className="page-footer black darken-3">
                <div className="container">
                <div className="row">

                    <div className="flex text-xs-center col l1 m2 s12">
                        {/* <img salt="" className="responsive-img"></img> */}
                        <p className="center">Y.X.</p>
                    </div>

                    <div className="col l5 offset-l1 m5 s12 hide-on-small-only">
                    <h5>Who is Y.X.?</h5>
                    <p>Y.X. graduated from uOttawa in 2020. She studied computer science and mathematics. She enjoys programming, travelling & playing instruments.</p>
                    </div>
              

                    <div className="col l4 offset-l1 m5 s12">
                    {/* <h5 className="white-text">Connect</h5> */}
                    <div className="text-xs-center mx my social-icons">
                    <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/crys___7" className=" btn-floating btn-small transparent" >
                        <i className="fab fa-instagram"></i>
                    </a>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/channel/UClv5NmxBvWIjid8crocDvZQ" className=" btn-floating btn-small transparent">
                        <i className="fab fa-youtube"></i>
                    </a>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/profile.php?id=100006981077508" className=" btn-floating btn-small transparent">
                        <i className="fab fa-facebook"></i>
                    </a>
                    <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/YueqingXie" className=" btn-floating btn-small transparent">
                        <i className="fab fa-twitter"></i>
                    </a>
                    </div>
                    </div>
                </div>
                </div>
                <div className="footer-copyright grey darken-4">
                <div className="container copyright center-align">Copyright &copy; 2020 Y.X.</div>
                </div>
            </footer>
  
            </section>
        )
    }
}

 




export default travelNoteMontreal;